import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LPOpen {
    isOpen: boolean;
}
const initialState: LPOpen = {
    isOpen: false,
};
const LPOpenSlice = createSlice({
    name: 'LPOpen',
    initialState,
    reducers: {
        setLPOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setLPOpen } = LPOpenSlice.actions;
export default LPOpenSlice.reducer;
